import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#27FF00',
  width = '100%',
  className = '',
  viewBox = '0 0 157.047 145.464',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Grupo_2731"
      data-name="Grupo 2731"
      transform="translate(-100.773 -163.467) rotate(-9)"
    >
      <g
        id="Grupo_2729"
        data-name="Grupo 2729"
        transform="translate(66.493 195.849)"
      >
        <path
          fill={fill}
          id="Caminho_4779"
          data-name="Caminho 4779"
          d="M160.8,248.212a2.549,2.549,0,0,1-2.562-2.562V200.933H129.063l-12.523,7.356a2.681,2.681,0,0,1-1.281.331H72.278v6.447a2.542,2.542,0,1,1-5.083,0v-9.01a2.549,2.549,0,0,1,2.562-2.562h44.8l12.523-7.315a2.691,2.691,0,0,1,1.281-.33H160.8a2.514,2.514,0,0,1,2.521,2.562V245.65A2.54,2.54,0,0,1,160.8,248.212Z"
          transform="translate(-38.228 -195.85)"
        />
        <path
          fill={fill}
          id="Caminho_4780"
          data-name="Caminho 4780"
          d="M160.221,259.441H94.674a2.6,2.6,0,0,1-2.356-1.529L66.694,200.135A2.666,2.666,0,0,1,66.9,197.7a2.544,2.544,0,0,1,2.149-1.157H160.1a2.558,2.558,0,0,1,2.356,1.488L174.4,225.056a2.574,2.574,0,0,1-1.281,3.389,2.544,2.544,0,0,1-3.389-1.322l-11.282-25.459H72.976l23.35,52.652h63.894a2.563,2.563,0,0,1,0,5.125Z"
          transform="translate(-66.493 -168.023)"
        />
      </g>
      <g
        id="Grupo_2730"
        data-name="Grupo 2730"
        transform="translate(132.985 253.337)"
      >
        <path
          fill={fill}
          id="Caminho_4781"
          data-name="Caminho 4781"
          d="M92.35,244.065a23.423,23.423,0,1,1,16.531-6.86A23.255,23.255,0,0,1,92.35,244.065Zm0-41.7a18.2,18.2,0,1,0,12.936,5.332A18.157,18.157,0,0,0,92.35,202.365Z"
          transform="translate(-35.234 -197.24)"
        />
        <path
          fill={fill}
          id="Caminho_4782"
          data-name="Caminho 4782"
          d="M71.985,214.978a2.562,2.562,0,1,1,0-5.125,9.525,9.525,0,0,0,9.505-9.547,2.575,2.575,0,0,1,2.563-2.562,2.549,2.549,0,0,1,2.562,2.563,14.6,14.6,0,0,1-14.63,14.671Z"
          transform="translate(-14.869 -176.915)"
        />
        <path
          fill={fill}
          id="Caminho_4783"
          data-name="Caminho 4783"
          d="M71.458,209.756a2.543,2.543,0,0,1-1.777-.743,2.473,2.473,0,0,1,0-3.6l6.53-6.572a2.572,2.572,0,0,1,3.637,3.637l-6.571,6.53A2.567,2.567,0,0,1,71.458,209.756Z"
          transform="translate(-35.668 -162.518)"
        />
        <path
          fill={fill}
          id="Caminho_4784"
          data-name="Caminho 4784"
          d="M76.161,238.3a7.089,7.089,0,0,1-5.083-2.108h0l-.868-.867a7.184,7.184,0,0,1,0-10.167l24.88-24.921a7.472,7.472,0,0,1,10.208,0l.868.868a7.182,7.182,0,0,1,0,10.166L81.245,236.188A7.09,7.09,0,0,1,76.161,238.3Zm24.053-35.047a1.964,1.964,0,0,0-1.488.62L73.805,228.791a2,2,0,0,0-.579,1.446,2.066,2.066,0,0,0,.579,1.447l.909.909h0a2.21,2.21,0,0,0,2.934,0l24.88-24.921a1.965,1.965,0,0,0,.62-1.488,1.938,1.938,0,0,0-.62-1.446l-.868-.868A1.94,1.94,0,0,0,100.214,203.25Z"
          transform="translate(-68.102 -157.789)"
        />
      </g>
    </g>
  </svg>
);

export default SVG;
